"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MISSING_IMAGE_SRC = exports.CaptionLocations = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var CaptionLocations;
(function (CaptionLocations) {
    CaptionLocations["BOTTOM"] = "bottom";
    CaptionLocations["TOP"] = "top";
})(CaptionLocations = exports.CaptionLocations || (exports.CaptionLocations = {}));
exports.MISSING_IMAGE_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var onImageError = function (evt) {
    evt && evt.target && evt.target.removeAttribute('src');
};
var Image = function (props) {
    var alt = props.alt, caption = props.caption, captionLocation = props.captionLocation, captionSize = props.captionSize, children = props.children, classes = props.classes, imageRatio = props.imageRatio, src = props.src, loadingAttributeValue = props.loadingAttributeValue, otherProps = __rest(props, ["alt", "caption", "captionLocation", "captionSize", "children", "classes", "imageRatio", "src", "loadingAttributeValue"]);
    return (react_1.default.createElement("figure", __assign({ className: getFigureClasses(imageRatio, classes) }, otherProps),
        react_1.default.createElement("img", { loading: loadingAttributeValue, src: src, alt: alt, className: "fds-image-media", onError: onImageError }),
        (children || caption) && (react_1.default.createElement("figcaption", { className: getFigureCaptionClasses(captionLocation, captionSize) }, children || caption))));
};
var getFigureClasses = function (imageRatio, classes) {
    return classnames_1.default('fds-image', "fds-image-ratio-" + imageRatio.replace(/:/g, '-'), classes);
};
var getFigureCaptionClasses = function (captionLocation, captionSize) {
    var _a;
    return classnames_1.default('fds-scrim', (_a = {
            'top-aligned fds-scrim-400 fds-type-400': captionLocation === CaptionLocations.TOP
        },
        _a["fds-scrim-" + captionSize] = captionLocation !== CaptionLocations.TOP,
        _a["fds-type-" + captionSize] = captionLocation !== CaptionLocations.TOP,
        _a));
};
Image.defaultProps = {
    loadingAttributeValue: 'lazy',
    captionLocation: CaptionLocations.BOTTOM,
    captionSize: 400,
    imageRatio: '16-9',
    src: exports.MISSING_IMAGE_SRC
};
exports.default = Image;
